/**
 * @generated SignedSource<<a8d9f03fa87723acf82abd0e8273ea75>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoCategoryScreenFilter_todoCategory$data = {
  readonly tags: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"FilterButtonTodoTags_tags">;
  }>;
  readonly " $fragmentType": "TodoCategoryScreenFilter_todoCategory";
};
export type TodoCategoryScreenFilter_todoCategory$key = {
  readonly " $data"?: TodoCategoryScreenFilter_todoCategory$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoCategoryScreenFilter_todoCategory">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoCategoryScreenFilter_todoCategory",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoCategoryTag",
      "kind": "LinkedField",
      "name": "tags",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FilterButtonTodoTags_tags"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TodoCategory",
  "abstractKey": null
};

(node as any).hash = "2f092a7f75413c3293e847ac7a863efa";

export default node;
